import {useRecordContext} from "react-admin";
import {Grid} from "@material-ui/core";
import SchoolTargetField from "./SchoolTargetField";
import WaveTargetField from "./WaveTargetField";
import NotificationTargetReferenceField from "./NotificationTargetReferenceField";

const NotificationTargetField = () => {
  const record = useRecordContext();
  const notificationPayload = record?.payload ? JSON.parse(record.payload) : null;

  switch (record.targetType) {
    case "school":
      return (
        <>
          <Grid item xs={3}>
            <SchoolTargetField schoolId={record.targetIds[0]}/>
          </Grid>
          <Grid item xs={9}></Grid>
        </>
      )
    case "bus_schedule":
      return (
        <>
          <Grid item xs={3}>
            <SchoolTargetField schoolId={notificationPayload?.SchoolId}/>
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item>
            <WaveTargetField isMultipleWave />
          </Grid>
        </>
      )
    case "route":
      return (
        <>
          <Grid item xs={3}>
            <SchoolTargetField schoolId={notificationPayload?.SchoolId}/>
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item xs={3}>
            <WaveTargetField waveId={notificationPayload?.BusScheduleId} />
          </Grid>
          <Grid item xs={9}></Grid>

          <Grid item>
            <NotificationTargetReferenceField
              referenceField="routes"
              referenceSourceField="targetIds"
              labelField="Route Name"
              labelSourceField="name"
              orderBy="name"
              orderType="ASC"
            />
          </Grid>
        </>
      )
    default:
      return <></>;
  }
};

export default NotificationTargetField;